import { createRouter, createWebHistory } from 'vue-router'
import FeedView from '../views/FeedView.vue'

const routes = [
  {
    path: '/',
    name: 'FeedView',
    component: FeedView
  },
  {
    path: '/RenderView/:id',
    name: 'RenderView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/RenderView.vue'),
    props: true
  },
  // {
  //   path: '/QueryView',
  //   name: 'QueryView',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/QueryView.vue'),
  //   props: true
  // },
  {
    path: '/Admin',
    name: 'Admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/AdminView.vue'),
    props: true
  },
  // 显式拦截已废弃的 QueryView 路径，强制跳转到首页
  { path: '/QueryView', redirect: '/' },
  // 兜底：所有未匹配路由都跳转回首页（防止白屏 / 访问已废弃路径）
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})


// router/index.js
// router.beforeEach((to, from, next) => {
//   let url = window.location.href;
//
//   // 检测是否包含 code 参数
//   if (url.indexOf('/?code') > -1) {
//     // 1. 提取 # 之前的部分作为基础路径
//     const baseUrl = url.replace(/#.*$/, '');
//     // 2. 提取 # 之后的部分作为路由路径（如果有）
//     const hashMatch = url.match(/#.*$/);
//     const hashPath = hashMatch ? hashMatch[0] : '';
//     // 3. 提取查询参数部分（包含 code 和 state）
//     const queryString = url.split('?')[1].split('#')[0];
//
//     // 4. 重新拼接成正确的哈希路由格式
//     // 最终效果: https://qyzh.com/#/RenderView/123?code=xxx&state=xxx
//     const newUrl = `${baseUrl}${hashPath}?${queryString}`;
//
//     // 5. 跳转到新 URL
//     window.location.href = newUrl;
//     return; // 必须 return，阻止继续执行 next()
//   }
//
//   next();
// });



export default router
